<template>
    <div class="pitanje-single">
        <PopupAnswer :activePopup="activePopup" @closePopup="closePopup"></PopupAnswer>

        <span class="tag">{{ tag }}</span>

        <p class="title" v-html="question && question.question"></p>

        <img class="img" v-if="question && question.image" :src="question && question.image" alt="Question image"/>

        <div class="answers">
        <template v-for="(answer, answerIndex) in answers">
            <OdgovorSingle :answer="answer" v-bind:key="answerIndex" v-model="questionAnswerId" :canClick="!lockedIn"> </OdgovorSingle>
        </template>
        <span></span>
        </div>

        <p class="desc">
            <span>Napomena: </span>
            Kada vrijeme za odgovor istekne, sustav će se sam prebaciti na sljedeće pitanje.
        </p>

        <!-- <div class="logo" Ovdje je bio background image, uklonjen je></div> -->

        <div class="button" @click.prevent="lockInAnswer()">
            <a href="#" class="button-1" v-bind:class="{'red': !lockedIn, 'blue': lockedIn, 'no-arrow': lockedIn}"><span>{{ lockedIn?'Odgovor zaključan':'Zaključaj odgovor' }}</span></a>
        </div>
    </div>
</template>

<script>
import { QuestionUtils } from '../utils/questionUtils.js'
import OdgovorSingle from './OdgovorSingle.vue'
import { ApplicationState } from '../application-state'
import { STORAGE_KEY } from '../utils/storageKey'
import PopupAnswer from './popups/PopupAnswer'
import { ObveznaLiga } from '../constants.js'

export default {
    name: 'pitanje-single',
    data: function () {
        return {
            lockedIn: this.getLockedInValue(STORAGE_KEY.ANSWER_LOCKED),
            hasImage: false,
            questionAnswerId: this.getQuestionAnswerId(STORAGE_KEY.QUESTION_ANSWER_ID),
            activePopup: false
        }
    },
    components: {
        OdgovorSingle,
        PopupAnswer
    },
    methods: {
        async postAnswer (quizKey = null, questionKey = null, answer = null, timeLeft = null) {
            try {
                if (quizKey == null) {
                    quizKey = this.round.quizKey
                }
                if (questionKey == null) {
                    questionKey = this.questionId
                }
                if (answer == null) {
                    answer = this.questionAnswerId
                }
                if (timeLeft == null) {
                    timeLeft = this.timeLeft
                }

                if (quizKey && answer) {
                    const postAnswerRequest = {
                        quizKey,
                        questionKey,
                        answer,
                        timeLeft
                    }
                    this.$db.answers.sendAnswer(postAnswerRequest)
                }
                this.sendGA(questionKey)
            } catch (error) {
                console.error(error)
            }
        },
        sendGA (questionKey) {
            let year = new Date().getFullYear()
            let liga = ObveznaLiga[this.userData.liga]
            let pitanje = Object.keys(this.round.questions).indexOf(String(questionKey)) + 1
            // eslint-disable-next-line no-undef
            gtag('event', 'click', {
                'event_category': `${year} - ${this.round.title} - ${liga}`,
                'event_label': `pitanje: ${pitanje}, odgovor: ${this.questionAnswerId ? this.questionAnswerId : 'nema odgovora'}`
            })
        },
        lockInAnswer () {
            try {
                if (!this.questionAnswerId) {
                    this.activePopup = true
                } else {
                    this.lockedIn = this.getLockedInValue(STORAGE_KEY.ANSWER_LOCKED)
                    if (!this.lockedIn) {
                        localStorage.setItem(STORAGE_KEY.QUESTION_ANSWER_ID, this.getLocalStorageObject(this.questionAnswerId))
                        this.postAnswer()
                    }
                }
            } catch (error) {
                console.error(error)
            }
            if (this.questionAnswerId) {
                this.lockedIn = true
                localStorage.setItem(STORAGE_KEY.ANSWER_LOCKED, this.getLocalStorageObject(true))
            }
        },
        sendAnswer (questionKey) {
            try {
                this.lockedIn = this.getLockedInValue(STORAGE_KEY.ANSWER_LOCKED)
                console.log(this.lockedIn, 2)
                if (!this.lockedIn) {
                    const quizKey = this.round.quizKey
                    const answerId = this.questionAnswerId
                    this.postAnswer(quizKey, questionKey, answerId, 0)
                }
            } catch (error) { }
            this.questionAnswerId = null
            this.lockedIn = false
            localStorage.setItem(STORAGE_KEY.ANSWER_LOCKED, this.getLocalStorageObject(false))
        },
        initialLoadData () {
            try {
                if (this.round.questions[this.questionId] === undefined) {
                    this.$router.push('/home')
                    return
                }
                // TODO Provjera currentquestion == pathQuestion, ako nije đibaj ga van
            } catch (error) {
                console.error(error)
                this.$router.push('/home')
            }
        },
        getLockedInValue (key) {
            return this.getFromLocalStorage(key)
        },
        getQuestionAnswerId (key) {
            let questionAnswerId = this.getFromLocalStorage(key)
            return questionAnswerId ? parseInt(questionAnswerId) : null
        },
        getFromLocalStorage (key) {
            try {
                let JSONobj = localStorage.getItem(key)
                if (JSONobj) {
                    let localStorageObj = JSON.parse(JSONobj)
                    if (localStorageObj.questionId === this.$route.params.id) {
                        return localStorageObj.value
                    } else {
                        localStorage.removeItem(key)
                    }
                }
                return undefined
            } catch (error) {
                return undefined
            }
        },
        getLocalStorageObject (value) {
            return JSON.stringify({
                questionId: this.questionId,
                value: value
            })
        },
        closePopup () {
            this.activePopup = false
        }
    },
    watch: {
        questionId (after, before) {
            this.activePopup = false
            if (!this.lockedIn) {
                const quizKey = this.round.quizKey
                const answerId = this.questionAnswerId
                this.postAnswer(quizKey, before, answerId, 0)
            }
            localStorage.removeItem(STORAGE_KEY.ANSWER_LOCKED)
            this.lockedIn = false
            this.questionAnswerId = 0
            localStorage.removeItem(STORAGE_KEY.QUESTION_ANSWER_ID)
        },
        appState (after, before) {
            if (before === ApplicationState.LOADING_DATA) {
                this.initialLoadData()
            }
        }
    },
    computed: {
        questionId () {
            return this.$route.params.id
        },
        round () {
            return this.$store.getters.round
        },
        tag () {
            try {
                return QuestionUtils.getTypeText(this.question.type)
            } catch (error) {}
            return ''
        },
        questions () {
            return this.round.questions
        },
        question () {
            try {
                return this.questions[this.questionId]
            } catch (error) { }
            return {}
        },
        answers () {
            try {
                if (this.question) {
                    return this.question.answers
                }
            } catch (error) {
                console.error(error)
            }
            return []
        },
        counters () {
            return this.$store.state.counters
        },
        timeLeft () {
            const timeUnitlQuizEnd = QuestionUtils.questionTimeUntilEnd(this.round, this.questionId)
            return this.counters.seconds - timeUnitlQuizEnd
        },
        appState () {
            return this.$store.state.appState
        },
        userData () {
            return this.$store.state.metadata.userData
        }
    },
    mounted: function () {
        if (this.appState !== ApplicationState.LOADING_DATA) {
            this.initialLoadData()
        }
    }
}
</script>

<style lang="scss" scoped>
.pitanje-single {
    position: relative;
    box-shadow: 0px 9px 16px 0px rgba(0,0,0,0.16);
    background-color: #fff;
    border-radius: 6px;
    padding: 46px 14px 16px;
    text-align: left;

    .tag {
        box-shadow: 0px 9px 10px 0px rgba(255,0,92,0.25);
        background: linear-gradient(135deg, rgba(255,0,132,1) 0%, rgba(255,0,29,1) 100%);
        font-family: "axiforma";
        position: absolute;
        top: 16px;
        left: 14px;
        display: block;
        border-radius: 6px;
        min-width: 50px;
        font-size: 10px;
        text-align: center;
        color: #fff;
        font-weight: 800;
        text-transform: uppercase;
        letter-spacing: 1px;
        padding: 5px 10px 4px;
        background-color: #08305d;
    }
    .title {
        font-family: "mPlus";
        font-size: 20px;
        letter-spacing: -.2px;
        line-height: 24px;
        color: #000;
        margin-bottom: 16px;
    }
    .desc {
        font-family: "axiforma";
        font-size: 12px;
        line-height: 18px;
        color: #adadae;
        letter-spacing: .5px;
        margin-bottom: 40px;

        span {
            color: #3d85ce;
        }
    }
    .img {
        position: relative;
        height: auto;
        width: auto;
        max-width: 100%;
        display: block;
        margin: 25px 0;
    }
    .answers {
        margin-bottom: 20px;
        font-family: "mPlus";
        font-size: 20px;
        letter-spacing: -.2px;
        color: #000;
    }
    .logo {
        display: block;
        width: 111px;
        height: 42px;
        background-position: 50%;
        background-size: contain;
        background-repeat: no-repeat;
        margin: auto;
    }
    .button {
        .button-1 {
            margin: 0 auto;
            position: relative;
            display: block;
            min-width: 200px;
            width: 80%;
        }
    }
}
@media only screen and (max-width: 380px) {
    .pitanje-single {
        .title {
            font-size: 18px;
            line-height: 20px;
        }
        .answers {
            font-size: 16px;
            line-height: 18px;
        }
    }
}
</style>
